import "./AllValueSet.scss";
import CircularButton, { CustomButton, CustomLoadingButton } from "../../../components/ui/CustomButton.jsx";
import newRequest from "../../../utils/newRequest.js";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
  Typography,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Popover
} from "@mui/material";
import { showToast } from "../../../toastService.js";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { GridLoader } from "react-spinners";
import { SlArrowDown } from "react-icons/sl";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import { FiSearch } from "react-icons/fi";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import AsyncSelect from "react-select/async";
import { useTranslation } from "react-i18next";
import { MdAdd, MdArrowBackIos, MdClose, MdDelete, MdEdit } from "react-icons/md";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports.jsx";
import { IoDocumentTextSharp } from "react-icons/io5";
import { fetchSystemCodes, logData } from "../../../utils/genericFunctions.js";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import { useRef } from "react";


const AllValueSet = () => {
  const { t } = useTranslation();
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isJobDialogOpen, setIsJobDialogOpen] = useState(false);
  const [valuesetAction, setJobAction] = useState(null);
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const location = useLocation();
  const showBack = location.state?.showBack || "N";
  const favMenu = location.state?.favMenu || "N";
  const menuDocid = location.state?.menuDocid || undefined;
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [detailsPerPage, setDetailsPerPage] = useState(5);
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
  const [valuesetPage, setJobPage] = useState(0);
  const [valueSets, setValueSets] = useState([]);
  const [sysType, setSysType] = useState(null);
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    new_doc_status: "",
    param1: "",
    param2: "",
  });
  const newCodeRef = useRef(null);
  const [valuesetCode, setJobCode] = useState("");
  const [valuesetTitle, setJobTitle] = useState("");
  const [valuesetSummary, setJobSummary] = useState("");
  const [valuesetExperience, setJobExperience] = useState("");
  const [valuesetStatus, setJobStatus] = useState({
    value: "New",
    label: "New"
  });
  const [applicableJobStatuses, setApplicableJobStatuses] = useState("");

  const [searchTerm, setSearchTerm] = useState("");
  const [responsibilitiesPage, setDependenciesPage] = useState(0);
  const [staticPage, setQualificationsPage] = useState(0);
  const [rowsPerPageDependencies, setRowsPerPageDependencies] = useState(5);
  const [rowsPerPageQualifications, setRowsPerPageQualifications] = useState(5);

  const [vsDependencies, setVsDependencies] = useState([]);
  const [vsStaticValues, setVsStaticValues] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [selectedDependency, setSelectedDependency] = useState(null);
  const [selectedStatic, setSelectedStatic] = useState(null);
  const [selectedJob, setSelectedJob] = useState(null);

  const [selectedSysCode, setSelectedSysCode] = useState(null);

  const [anchorEl, setAnchorEl] = useState(null);
  const popoverOpen = Boolean(anchorEl);
  const id = popoverOpen ? 'simple-popover' : undefined;


  const fetchValueSets = async () => {
    try {
      const res = await newRequest.post("/valueSet/findAll", {
        search: "",
        vs_validation_type: "",
        vs_is_active: "",
        page: 1,
        limit: 100
      });

      logData("fetchSets", res.data);

      if (res.data?.data) {
        const sortedSets = res.data?.data?.sort((a, b) =>
          new Date(b.vs_code) - new Date(a.vs_code)
        );
        setValueSets(sortedSets);
      } else {
        setValueSets([]);
      }
    } catch (error) {
      console.error("Error fetching valueSets:", error);
    }
  };

  const definedStatuses = async () => {
    try {
      const options = ["New", "Active", "Under Review", "Closed"]?.map((val) => ({
        value: val,
        label: val,
      }));
      setApplicableJobStatuses(options);
    } catch (error) {
      console.error("Error fetching defined sectors :", error);
    }
  };

  const handleJobChangePage = (event, newPage) => {
    setJobPage(newPage);
  };

  const handleVsetChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(8));
    setJobPage(0);
  };

  const filteredValueSets = valueSets?.filter(
    (item) =>
      item.vs_name?.toLowerCase().includes(searchTerm?.toLowerCase())
  );

  const slicedValueSets = filteredValueSets?.slice(
    valuesetPage * rowsPerPage,
    valuesetPage * rowsPerPage + rowsPerPage
  );


  const handleAccodionChange = (panel, valueset) => (event, isExpanded) => {
    try {
      setExpanded(isExpanded ? panel : false);
      setSelectedJob(valueset);
      setVsDependencies(valueset?.vs_dependencies);
      setVsStaticValues(valueset?.vs_static_values);
    } catch (error) {
      console.log(error)
    }
  };


  const handleDependenciesChangePage = (event, newPage) => {
    setDependenciesPage(newPage);
  };

  const handleDependenciesChangeRowsPerPage = (event) => {
    setRowsPerPageDependencies(parseInt(event.target.value, 5));
    setDependenciesPage(0);
  };

  const filteredDependenciesData = vsDependencies;
  const slicedDependenciesData = filteredDependenciesData.slice(
    responsibilitiesPage * detailsPerPage,
    responsibilitiesPage * detailsPerPage + detailsPerPage
  );

  const filteredStaticValues = vsStaticValues;
  const slicedStaticValues = filteredStaticValues.slice(
    staticPage * detailsPerPage,
    staticPage * detailsPerPage + detailsPerPage
  );

  const handleQualificationsChangeRowsPerPage = (event) => {
    setRowsPerPageQualifications(parseInt(event.target.value, 5));
    setQualificationsPage(0);
  };

  const handleQualificationsChangePage = (event, newPage) => {
    setQualificationsPage(newPage);
  };




  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "deleteResponsibility") {
        await newRequest.post("/glJob/delResponsibility", {
          valueset_docid: selectedJob._id,
          branch_code: objectToAction.object_id
        });
        fetchValueSets();
      }
    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };

  const handleCancel = () => {
    setIsConfirmDialogOpen(false);
  };

  const handleJobAction = async () => {
    try {
      if (!valuesetCode) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter code!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!valuesetTitle) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter title!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (valuesetAction === "addJob") {
        const res = await newRequest.post(
          "/hrJob/add",
          {
            vs_code: valuesetCode,
            vs_name: valuesetTitle,
            valueset_summary: valuesetSummary || valuesetTitle || "",
            valueset_experience: valuesetExperience || "",
            valueset_responsibilities: [],
            valueset_static: [],
          }
        );
        if (res.data?.msg === "added") {
          setValueSets((prevData) => {
            const updated = [...prevData, res.data?.doc];
            return updated.sort(
              (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
            );
          });
          setIsJobDialogOpen(false);
          showToast(`${valuesetTitle} added!`, "success");
          resetAction();
        } else if (res.data?.msg === "exists") {
          showToast(t('valuesetCodeExists', { param1: valuesetCode }), "error");
        } else {
          showToast(res.data?.msg, "error");
        }
      } else if (valuesetAction === "editJob") {
        const res = await newRequest.put(
          `/hrJob/upd/${selectedJob._id}`,
          {
            vs_name: valuesetTitle,
            valueset_summary: valuesetSummary || valuesetTitle || "",
            valueset_experience: valuesetExperience || "",
            vs_is_active: valuesetStatus?.value || "New",
          }
        );
        if (res.data?.msg === "updated") {
          const updatedJob = res.data?.doc;
          setValueSets((prevJobs) => { return prevJobs.map((valueset) => valueset?._id === updatedJob?._id ? updatedJob : valueset); });
          setIsJobDialogOpen(false);
          showToast(`${valuesetTitle} updated!`, "success");
          resetAction();
        } else {
          showToast("Error updating valueset!", "error");
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  const resetAction = () => {
    setJobAction(null);
    setJobCode("");
    setJobTitle("");
    setJobSummary("");
    setJobExperience("");
    setJobStatus(null);
  };


  useEffect(() => {
    fetchValueSets();
    definedStatuses();
  }, []);



  return (
    <motion.div
      className="valueset"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      <div className="valueset-navbar">
        <div className="valueset-navbar-left">
          <div className="homeSearch">
            <FiSearch className="homeSearchIcon" />
            <input
              className="homeSearchInput"
              type="text"
              placeholder={`${t('search')} ${t('valueSet')}`}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            {searchTerm?.length > 0 && (
              <MdClose
                onClick={() => setSearchTerm("")}
                className="homeSearchClear"
              />
            )}
          </div>
        </div>
        <div className="valueset-navbar-right">
          <CustomLoadingButton
            currentTheme={currentTheme}
            borderRadiusType="both"
            variant="tint"
            color="#0ea5a4"
            tooltip={"Add new Value Set"}
            iconPosition="end"
            endIcon={<MdAdd />}
            onClick={() => {
              try {
                resetAction();
                setJobAction("addValueSet");
                setIsJobDialogOpen(true);
              } catch (error) {
                console.log(error);
              }
            }}
          >
            {t('addValueSet')}
          </CustomLoadingButton>
          <CustomLoadingButton
            currentTheme={currentTheme}
            iconPosition="end"
            borderRadiusType="both"
            variant="tint"
            color="#2563EB"
            tooltip="Run reports for this document"
            endIcon={<IoDocumentTextSharp />}
            onClick={() => setReportsDialogOpen(true)}>
            {t('reports')}
          </CustomLoadingButton>
          {/* This part shows if the menu was opened from home screen */}
          {showBack === "Y" && <hr className="separator-v" />}
          {showBack === "Y" &&
            <span className="back-icon" onClick={() => navigate(-1)}>
              <MdArrowBackIos size={24} />
            </span>}
        </div>
      </div>
      {slicedValueSets?.length > 0 &&
        <div className="valueset-table-content">
          <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }}
            className="table-container">
            <Table sx={{ width: "max-content", border: 'none' }}>
              <TableBody className="tablebody-accordion">
                {slicedValueSets?.map((valueset, index) => (
                  <TableRow
                    key={valueset?._id}
                    className="tablerow-accordion">
                    <TableCell className="table-cell-accordion"
                      style={{
                        display: "flex",
                        width: "100%",
                        alignItems: "center",
                        justifyContent: "center"
                      }}>
                      <Accordion className="accordion" expanded={expanded === valueset?._id} onChange={handleAccodionChange(valueset?._id, valueset)}>
                        <AccordionSummary
                          className="accordion-summary"
                          expandIcon={<SlArrowDown className="content-accordion-expand-icon" style={{ color: "#f44336", fontWeight: "bold" }} />}
                          id={`panel-${valueset?._id}-header`}
                        >
                          <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%", marginRight: "10px" }}>
                            <Typography>
                              <div style={{ display: "flex", flexDirection: "row", alignItems: "flex-start", width: "100%", gap: "10px" }}>
                                <span className="normal-title">{valuesetPage * rowsPerPage + index + 1}.</span>
                                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", width: "100%" }}>
                                  <span className="normal-title">{valueset?.vs_code}</span>
                                  <span className="sub-title soft" style={{ fontSize: "12px" }}>{valueset?.vs_name}</span>
                                </div>
                              </div>
                            </Typography>
                            <Typography>
                              <div className="valueset-details-wrapper">
                                <div className={`valueset-details status new`}>
                                  <span className="account-no">{`${t('validation').toUpperCase()}: ${valueset?.vs_validation_type}`}</span>
                                  <span className="account-no">{`${t('enabled').toUpperCase()}: ${valueset?.vs_is_active}`}</span>
                                </div>
                                <CircularButton
                                  currentTheme={currentTheme}
                                  onClick={async (e) => {
                                    try {
                                      setJobCode(valueset?.vs_code);
                                      setJobTitle(valueset?.vs_name);
                                      setJobSummary(valueset?.valueset_summary);
                                      setJobExperience(valueset?.valueset_experience);
                                      setJobStatus({
                                        value: valueset?.vs_is_active,
                                        label: valueset?.vs_is_active
                                      });
                                      setJobAction("editJob");
                                      setIsJobDialogOpen(true);
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}
                                  icon={<MdEdit />}
                                  width={"30px"}
                                  height={"30px"} />
                              </div>
                            </Typography>
                          </div>
                        </AccordionSummary>
                        <AccordionDetails className="accordion-details">
                          <div className="accordion-table">
                            <div className="accordion-left">
                              <div style={{ display: "flex", flexDirection: "row", gap: "3px", alignItems: "center" }}>
                                <span className="sub-title">{t('staticValues')}</span>
                                <CircularButton
                                  currentTheme={currentTheme}
                                  aria-describedby={id}
                                  onClick={(e) => {
                                    try {
                                      setSysType("Job Qualifications");
                                      setSelectedSysCode(null);
                                      setAnchorEl(e.currentTarget);
                                      if (newCodeRef.current) {
                                        newCodeRef.current.focus();
                                      }
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}
                                  icon={<MdAdd />}
                                  width={"30px"}
                                  height={"30px"} />
                              </div>
                              <div className="table-content">
                                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                  <Table sx={{ width: "max-content", border: 'none' }}>
                                    <TableBody className="tablebody">
                                      {slicedStaticValues?.map((row, index) => (
                                        <TableRow
                                          key={row?.code}
                                          className={`${selectedStatic?.code === row?.code ? "tablerow current" : "tablerow"}`}
                                          onClick={() => setSelectedStatic(row)}
                                        >
                                          <TableCell className="table-cell center" style={{ maxWidth: "40px" }}>
                                            {/* {staticPage * rowsPerPage + index + 1} */}
                                            {row?.order}
                                          </TableCell>
                                          <TableCell className="table-cell left" style={{ maxWidth: "150px" }}>
                                            <span className="sub-title">{row?.code}</span>
                                          </TableCell>
                                          <TableCell className="table-cell left" style={{ width: "auto" }}>
                                            <span className="sub-title">{row?.label}</span>
                                          </TableCell>
                                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                            <CircularButton
                                              currentTheme={currentTheme}
                                              onClick={async (e) => {
                                                try {
                                                  const res = await newRequest.post(`/hrJob/delQual/${selectedJob._id}`, { selected_code: row?.qual_code_xx });
                                                  if (res.data?.msg === "removed") {
                                                    setVsStaticValues((prevData) => prevData.filter(doc => doc !== row));
                                                    showToast("Removed!", "success");
                                                  } else {
                                                    showToast("Error removing qualification!", "error");
                                                  }
                                                } catch (error) {
                                                  console.log(error);
                                                }
                                              }}
                                              color="#E53935"
                                              icon={<MdDelete />}
                                              width={"30px"}
                                              height={"30px"} />
                                          </TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                  {vsStaticValues.length > rowsPerPageQualifications &&
                                    <TablePagination
                                      rowsPerPageOptions={[5]}
                                      rowsPerPage={rowsPerPageQualifications}
                                      onRowsPerPageChange={handleQualificationsChangeRowsPerPage}
                                      component="div"
                                      count={vsStaticValues.length}
                                      page={staticPage}
                                      onPageChange={handleQualificationsChangePage}
                                    />}
                                </TableContainer>
                              </div>
                            </div>
                            <div className="accordion-right">
                              <div style={{ display: "flex", flexDirection: "row", gap: "3px", alignItems: "center", paddingLeft: "5px" }}>
                                <span className="sub-title">{t('dependencies')}</span>
                                <CircularButton
                                  currentTheme={currentTheme}
                                  aria-describedby={id}
                                  onClick={(e) => {
                                    try {
                                      setSysType("Job Dependencies");
                                      setSelectedSysCode(null);
                                      setAnchorEl(e.currentTarget);
                                      if (newCodeRef.current) {
                                        newCodeRef.current.focus();
                                      }
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}
                                  icon={<MdAdd />}
                                  width={"30px"}
                                  height={"30px"} />
                              </div>
                              <div className="table-content">
                                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                  <Table sx={{ width: "max-content", border: 'none' }}>
                                    <TableBody className="tablebody">
                                      {slicedDependenciesData?.map((row, index) => (
                                        <TableRow
                                          key={row?.resp_code_xx}
                                          className={`${selectedDependency === row ? "tablerow current" : "tablerow"}`}
                                          onClick={() => setSelectedDependency(row)}
                                        >
                                          <TableCell className="table-cell center" style={{ maxWidth: "40px" }}>
                                            {responsibilitiesPage * rowsPerPage + index + 1}
                                          </TableCell>
                                          <TableCell className="table-cell left" style={{ width: "auto" }}>
                                            <span className="sub-title">{row}</span>
                                          </TableCell>
                                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                            <CircularButton
                                              currentTheme={currentTheme}
                                              onClick={async (e) => {
                                                try {
                                                  const res = await newRequest.post(`/hrJob/delResp/${selectedJob._id}`, { selected_code: row?.resp_code_xx });
                                                  if (res.data?.msg === "removed") {
                                                    setVsDependencies((prevData) => prevData.filter(doc => doc !== row));
                                                    showToast("Removed!", "success");
                                                  } else {
                                                    showToast("Error removing responsibility!", "error");
                                                  }
                                                } catch (error) {
                                                  console.log(error);
                                                }
                                              }}
                                              color="#E53935"
                                              icon={<MdDelete />}
                                              width={"30px"}
                                              height={"30px"} />
                                          </TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                  {vsDependencies?.length > rowsPerPageDependencies &&
                                    <TablePagination
                                      rowsPerPageOptions={[5]}
                                      rowsPerPage={rowsPerPageDependencies}
                                      onRowsPerPageChange={handleDependenciesChangeRowsPerPage}
                                      component="div"
                                      count={vsDependencies?.length}
                                      page={responsibilitiesPage}
                                      onPageChange={handleDependenciesChangePage}
                                    />}
                                </TableContainer>
                              </div>
                            </div>

                          </div>
                        </AccordionDetails>
                      </Accordion>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            {filteredValueSets.length > rowsPerPage &&
              <TablePagination
                rowsPerPageOptions={[8]}
                rowsPerPage={rowsPerPage}
                onRowsPerPageChange={handleVsetChangeRowsPerPage}
                component="div"
                count={filteredValueSets.length}
                page={valuesetPage}
                onPageChange={handleJobChangePage}
              />}
          </TableContainer>
        </div>
      }
      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} variant="tint" color="#E040FB" onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={handleCancel}
        onConfirm={handleConfirm}
        dialogTitle={t('confirmation')}
        dialogContent={<p>{objectToAction.action_text}</p>}
      />
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <GridLoader
              color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>
      )}
      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroupArray={["hr-valueSets"]}
                documentData={{
                  docNo: "1",
                  docType: "HR Jobs",
                  docId: "1"
                }} />
            </div>
          </div>
        </motion.div>
      )}
      {isJobDialogOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title" style={{ textTransform: "uppercase" }}>{valuesetAction === "addJob" ? t('addJob') : t('editJob')}</h1>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => {
                  try {
                    resetAction();
                    setIsJobDialogOpen(false);
                  } catch (error) {
                    console.log(error);
                  }
                }} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <div style={{ display: "flex", width: "100%", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                <div className="input-item-with-label">
                  <label htmlFor="vs_code" style={{ width: "100px" }}>
                    {t('code').toUpperCase()}
                  </label>
                  <input
                    name="vs_code"
                    type="text"
                    placeholder={t('code').toUpperCase()}
                    className="form-input-item"
                    style={{ width: "130px" }}
                    value={valuesetCode}
                    onChange={(e) => setJobCode(e.target.value)}
                    disabled={valuesetAction === "editJob"}
                  />
                </div>
                <div className="input-item-with-label" style={{ alignSelf: "flex-end" }}>
                  <Select
                    id="vs_is_active"
                    name="vs_is_active"
                    menuPortalTarget={document.body}
                    styles={{
                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                      menuPortal: base => ({
                        ...base,
                        zIndex: 9999,
                      })
                    }}
                    width="130px"
                    value={valuesetStatus}
                    onChange={(selectedOption) => setJobStatus(selectedOption)}
                    options={applicableJobStatuses}
                    isSearchable={true}
                    placeholder={t('status')}
                  />
                </div>
              </div>
              <div className="input-item-with-label">
                <label htmlFor="vs_name" style={{ width: "100px" }}>
                  {t('title').toUpperCase()}
                </label>
                <input
                  name="vs_name"
                  type="text"
                  placeholder={t('title').toUpperCase()}
                  className="form-input-item"
                  style={{ width: "350px" }}
                  value={valuesetTitle}
                  onChange={(e) => setJobTitle(e.target.value)}
                />
              </div>
              <div className="input-item-with-label">
                <label htmlFor="valueset_summary" style={{ width: "100px" }}>
                  {t('summary').toUpperCase()}
                </label>
                <input
                  name="valueset_summary"
                  type="text"
                  placeholder={t('summary').toUpperCase()}
                  className="form-input-item"
                  style={{ width: "350px" }}
                  value={valuesetSummary}
                  onChange={(e) => setJobSummary(e.target.value)}
                />
              </div>
              <div className="input-item-with-label">
                <label htmlFor="valueset_experience" style={{ width: "100px" }}>
                  {t('experience').toUpperCase()}
                </label>
                <input
                  name="valueset_experience"
                  type="text"
                  placeholder={t('experience').toUpperCase()}
                  className="form-input-item"
                  style={{ width: "350px" }}
                  value={valuesetExperience}
                  onChange={(e) => setJobExperience(e.target.value)}
                />
              </div>
            </div>
            <div className="overlay-actions">
              <CustomLoadingButton
                iconPosition="end"
                currentTheme={currentTheme}
                borderRadiusType="right"
                onClick={handleJobAction}>
                {valuesetAction === "addJob" ? t('add').toUpperCase() : t('update').toUpperCase()}
              </CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}
      <Popover
        id={id}
        open={popoverOpen}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <div style={{ padding: "20px" }}>
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "max-content",
            marginBottom: "5px"
          }}>
            <span className="main-title">{t('add').toUpperCase()}</span>
            <CircularButton currentTheme={currentTheme}
              onClick={() => {
                try {
                  setAnchorEl(null);
                  setSysType(null);
                  setSelectedSysCode(null);
                } catch (error) {
                  console.log(error);
                }
              }} icon={<MdClose />} width={"35px"} height={"35px"} />
          </div>
          <div className="input-item-with-label" style={{ gap: "3px" }}>
            <AsyncSelect
              ref={newCodeRef}
              id="selectedSysCode"
              name="selectedSysCode"
              menuPortalTarget={document.body}
              styles={{
                ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                menuPortal: base => ({
                  ...base,
                  zIndex: 9999,
                })
              }}
              width="300px"
              value={selectedSysCode}
              onChange={(selectedOption) => setSelectedSysCode(selectedOption)}
              loadOptions={(inputValue, callback) => fetchSystemCodes(inputValue, callback, sysType)}
              isSearchable={true}
              placeholder={sysType === "Job Qualifications" ? t('static').toUpperCase() : t('responsibilities').toUpperCase()}
              noOptionsMessage={() => "Type Minimum 2 Letter to Search"} />
            <CustomLoadingButton
              currentTheme={currentTheme}
              iconPosition="end"
              borderRadiusType="right"
              endIcon={<MdAdd />}
              onClick={async () => {
                try {
                  let addingType = "";
                  let url = "";
                  let title = "";

                  if (sysType === "Job Qualifications") {
                    addingType = t('selectQualification');
                    title = t('qualification');
                    url = `/hrJob/addQual/${selectedJob._id}`;
                  } else if (sysType === "Job Dependencies") {
                    addingType = t('selectResponsibility');
                    title = t('responsibility');
                    url = `/hrJob/addResp/${selectedJob._id}`;
                  }

                  if (!selectedSysCode) {
                    setNotifyDialogTitle("Note!");
                    setNotifyDialogText(addingType);
                    setIsNotifyDialogOpen(true);
                    return;
                  }

                  const res = await newRequest.post(url, { selected_code: selectedSysCode?.value });

                  if (res.data?.msg === "exists") {
                    setSelectedSysCode(null);
                    showToast(t('qualRespExists', { param1: title, param2: selectedSysCode?.label }), "error");
                    if (newCodeRef.current) {
                      newCodeRef.current.focus();
                    }
                  } else if (res.data?.msg === "added") {
                    if (sysType === "Job Dependencies") {
                      setVsDependencies((prevData) => {
                        const updated = [...prevData, res.data?.doc];
                        return updated.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
                      });
                    } else if (sysType === "Job Qualifications") {
                      setVsStaticValues((prevData) => {
                        const updated = [...prevData, res.data?.doc];
                        return updated.sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt));
                      });
                    }
                    showToast(`${selectedSysCode?.label} added!`, "success");
                    if (newCodeRef.current) {
                      newCodeRef.current.focus();
                    }
                    setSelectedSysCode(null);
                  } else {
                    showToast(res.data?.msg, "error");
                  }

                } catch (error) {
                  console.log(error);
                }
              }}>
              {t('add')}
            </CustomLoadingButton>
          </div>
        </div>
      </Popover>
    </motion.div>
  );
};

export default AllValueSet;
